"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRefresh = exports.setStatus = exports.setMethod = exports.setEndpoint = exports.setTo = exports.setFrom = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const now = new Date();
const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);
function isoLocal(d) {
    const pad = (n) => String(n).padStart(2, '0');
    const y = d.getFullYear();
    const m = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const h = pad(d.getHours());
    const mm = pad(d.getMinutes());
    return `${y}-${m}-${day}T${h}:${mm}`;
}
const initialState = {
    from: isoLocal(oneHourAgo),
    to: isoLocal(now),
    endpoint: '',
    method: '',
    status: '',
    refresh: 30,
};
const filtersSlice = (0, toolkit_1.createSlice)({
    name: 'filters',
    initialState,
    reducers: {
        setFrom: (state, action) => { state.from = action.payload; },
        setTo: (state, action) => { state.to = action.payload; },
        setEndpoint: (state, action) => { state.endpoint = action.payload; },
        setMethod: (state, action) => { state.method = action.payload; },
        setStatus: (state, action) => { state.status = action.payload; },
        setRefresh: (state, action) => { state.refresh = action.payload; },
    }
});
_a = filtersSlice.actions, exports.setFrom = _a.setFrom, exports.setTo = _a.setTo, exports.setEndpoint = _a.setEndpoint, exports.setMethod = _a.setMethod, exports.setStatus = _a.setStatus, exports.setRefresh = _a.setRefresh;
exports.default = filtersSlice.reducer;
